export default __webpack_public_path__ + "static/media/no-order.5079d228.svg";